// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__1ZynY","text":"footer_text__2sAer"};